import { Grid, Paper, Skeleton, Stack } from "@mui/material";

export default function UsersSkeleton() {
  return (
    <Stack spacing={2.5}>
      <Skeleton variant="rounded" height={72} />

      <Grid container spacing={2.5}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Skeleton variant="text" width="50%" />
              <Skeleton variant="text" width="70%" height={36} />
              <Skeleton variant="text" width="60%" />
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Skeleton variant="rounded" height={260} />

      <Grid container spacing={2.5}>
        <Grid item xs={12} md={6}>
          <Skeleton variant="rounded" height={190} />
        </Grid>
        <Grid item xs={12} md={6}>
          <Skeleton variant="rounded" height={190} />
        </Grid>
      </Grid>

      <Skeleton variant="rounded" height={270} />
    </Stack>
  );
}
